import api from './axios';

/** Normaliza respuesta de lista (array directo o paginada con .results). */
function toList(data) {
    if (Array.isArray(data)) return data;
    if (data && Array.isArray(data.results)) return data.results;
    return [];
}

export const getNews = async () => {
    const response = await api.get('noticias/');
    return toList(response.data);
};

export const getCourses = async () => {
    const response = await api.get('cursos/');
    return toList(response.data);
};

export const getConfig = async () => {
    const response = await api.get('configuracion/');
    return response.data;
};

export const getCarousel = async () => {
    const response = await api.get('carrusel/');
    return toList(response.data);
};

export const sendAsesoriaContact = async (data) => {
    const response = await api.post('public/asesoria/', data);
    return response.data;
};